// extracted by mini-css-extract-plugin
module.exports = {"app":"wrapper2_app__3YfN2"};